import React from "react";
import styles from "../../assets/styles/Charge/Charge.module.scss";
import {
  MimaButton,
  MimaDropdown,
  MimaInput,
  MimaText,
  Modal,
  ReceiptCheckBox as RCB,
} from "../../components";
import { Formik } from "formik";

const GiveSubscription = ({
  closeModal,
  onSubmit,
  validationSchema,
  loading,
  plans,
  item,
  isSignedUpBusiness,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={4} width={40} align="center">
        {`Give Subscription to ${isSignedUpBusiness ? item.tradingName : item?.business?.tradingName}`}
      </MimaText>
      <Formik
        initialValues={{
          business: isSignedUpBusiness
            ? item.subscription.business
            : item?.business?._id,
          amountPaid: isSignedUpBusiness
            ? item?.subscription?.amountPaid
            : item?.amountPaid,
          plan: isSignedUpBusiness ? item.subscription.plan : item?.plan?._id,
          months: isSignedUpBusiness
            ? item?.subscription?.months
            : item?.months,
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <>
            <MimaInput
              labelTitle="Amount Paid"
              name="amountPaid"
              value={values.amountPaid}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.amountPaid}
              touched={touched.amountPaid}
              //   disabled={true}
            />

            <MimaDropdown
              labelTitle="Plan"
              placeholder={item ? item.plan.name : "Select"}
              name="plan"
              data={plans}
              value={values.plan}
              currentValue={values.plan}
              id="plan"
              onChange={(data) => {
                setFieldValue("plan", data.key);
              }}
              error={errors.plan}
              disabled={true}
              touched={touched.plan}
            />

            <MimaInput
              labelTitle="Months"
              name="months"
              value={values.months}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.months}
              touched={touched.months}
              //   disabled={true}
            />

            <MimaButton
              title="Continue"
              width={38}
              mt={2}
              buttonColor="var(--color-dark-4)"
              onClick={handleSubmit}
              loading={loading}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};
export default GiveSubscription;
